import React from 'react';
import { Play, Sparkles } from 'lucide-react';
import Background from '../components/Background';

export default function Showcase() {
  const videos = [
    { id: 'oV6AJTWnfu0?si=_ZH6V8FUqt_5GPWG', title: 'Showcase 1' },
    { id: '3p_1gklMbNc?si=Ap-jSHwBO63cnbrz', title: 'Showcase 2' },
    { id: 'byE-JnFMckg?si=byE-JnFMckg', title: 'Showcase 3' },
    { id: 'FVUchdGu3UE?si=FVUchdGu3UE', title: 'Showcase 4' },
    { id: 'MU5dFF8CXI4?si=MU5dFF8CXI4', title: 'Showcase 5' },
    { id: 'QPARXmRJvuY?si=QPARXmRJvuY', title: 'Showcase 6' }
  ];

  return (
    <>
      <Background />
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16 relative">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] bg-purple-500/20 rounded-full blur-[100px]" />
          <h1 className="text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-fuchsia-500 to-purple-600">
            Featured Showcases
          </h1>
          <div className="flex items-center justify-center gap-3 text-xl text-gray-300">
            <Sparkles className="w-5 h-5 text-purple-400" />
            <p className="font-light">Watch Synapse X in Action</p>
            <Sparkles className="w-5 h-5 text-purple-400" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <div 
              key={video.id} 
              className="group relative"
              style={{
                animation: `fadeIn 0.5s ease-out ${index * 0.1}s backwards`
              }}
            >
              <div className="aspect-video relative overflow-hidden rounded-xl">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  className="w-full h-full absolute inset-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-fuchsia-500/10 group-hover:opacity-0 transition-opacity duration-300" />
                  <div className="absolute inset-0 ring-1 ring-purple-500/20 group-hover:ring-purple-500/40 rounded-xl transition-all duration-300" />
                  <div className="absolute inset-0 shadow-[0_0_15px_rgba(168,85,247,0.2)] group-hover:shadow-[0_0_30px_rgba(168,85,247,0.4)] rounded-xl transition-all duration-300" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}